import React, {FC, useState} from "react"
import {Row} from "react-bootstrap"

import Flex from "@irati/ui/src/Flex"
import {H4, Body} from "@irati/ui/src/Typography"
import {injectIntl, InjectIntl, FormattedMessage} from "@irati/utils/lang"
import Button from "@irati/ui/src/Button"
import {Input} from "@irati/ui/src/FormItem"
import {Hr} from "@irati/ui/src/Layout"

interface Props extends InjectIntl {
  currentValue: string
  onUpdate: (v: string) => void
  title: string
  isEditable?: boolean
  editText?: string
}

const RenewalDetail: FC<Props> = ({currentValue, onUpdate, title, editText, isEditable = true}) => {
  const [isEditing, setEditing] = useState<boolean>(false)
  const [value, setValue] = useState<string>(currentValue)

  const handleSave = () => {
    onUpdate(value)
    setEditing(false)
  }

  const handleCancel = () => {
    setValue(currentValue)
    setEditing(false)
  }

  return (
    <>
      <Hr />
      <Flex height="20px" justifyContent="space-between" alignItems="center">
        <Body>
          <FormattedMessage id={title} />
        </Body>
        {isEditing ? (
          <Flex alignItems="center">
            <Row>
              <Input name="renewalDetail" value={value} onChange={setValue} />
            </Row>
            <div>
              <Button tertiary marginLeft={2} onClick={handleSave}>
                <FormattedMessage id="platform.button.save" />
              </Button>
              <Button tertiary marginLeft={2} onClick={handleCancel}>
                <FormattedMessage id="platform.button.cancel" />
              </Button>
            </div>
          </Flex>
        ) : (
          <Flex width="50%" justifyContent="space-between">
            <H4>{currentValue}</H4>
            {isEditable && (
              <Button tertiary onClick={() => setEditing(true)}>
                <FormattedMessage id={editText} />
              </Button>
            )}
          </Flex>
        )}
      </Flex>
    </>
  )
}

export default injectIntl(RenewalDetail)
